import React from 'react'
import {
  Switch,
  Route,
} from 'react-router-dom'
import {
  AppearContainer,
  HouseTypeRoot,
  HouseTypeDetail,
  NotFound,
} from '../../'

const HouseType = (props) => {
  const {
    currentPath,
  } = props

  return (
    <AppearContainer transitionKey={currentPath.join()}>
      <Switch>
        <Route
          exact
          path="/haustyp"
          component={HouseTypeRoot}
        />
        <Route
          path="/haustyp/:id"
          component={HouseTypeDetail}
        />
        <Route component={NotFound} />
      </Switch>
    </AppearContainer>
  )
}

export default HouseType



// WEBPACK FOOTER //
// ./src/modules/houseType/components/houseType.jsx